module.exports = __webpack_public_path__ + "static/media/layout4-vid.4f769652.svg";